module.exports = __webpack_public_path__ + "img/loading.ff18de9e.gif";